//******************************************************************************
//
//  SOURCE FILE:  catalog.g.ts
//
//  Copyright (c) 2020 by Honeywell Intelligrated.
//  The information contained herein is the confidential and proprietary
//  information of Honeywell Intelligrated.  This information is protected,
//  among others, by the patent, copyright, trademark, and trade secret laws of
//  the United States and its several states.  Any use, copying, or reverse
//  engineering is strictly prohibited.  This software has been developed at
//  private expense and accordingly, if used under Government contract, the use,
//  reproduction or disclosure of this information is subject to the
//  restrictions set forth under the contract between Honeywell Intelligrated
//  and its customer.  By viewing or receiving this information, you consent to
//  the foregoing.
//
//******************************************************************************

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
//  AUTO-GENERATED FILE.  ALL MANUAL MODIFICATIONS WILL BE LOST!!!
//
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

const catalog = {

    /**
     * Get UI version info.
     */
    getVersionInfo() {
        return require("../versionInfo.json");
    },

    /**
     * Get all available component catalog module names.
     */
    getModuleNames() {
        let names: Array<string> = [];
        names.push("@momentum-ui/framework/administration");
        names.push("@momentum-ui/framework/samples");
        names.push("@momentum-ui/framework/system");
        names.push("@momentum-ui/reds-ui-extensions/Test");
        names.push("@momentum-ui/smui/ASRS");
        names.push("@momentum-ui/smui/ASRSDashboardConfig");
        names.push("@momentum-ui/smui/ASRSGTPDashboard");
        names.push("@momentum-ui/smui/ASRSKpis");
        names.push("@momentum-ui/smui/Dashboard");
        names.push("@momentum-ui/smui/DataTableDialog");
        names.push("@momentum-ui/smui/ACRSummary");
        names.push("@momentum-ui/smui/ASRSTaskSummary");
        names.push("@momentum-ui/smui/CraneSummary");
        names.push("@momentum-ui/smui/GTPStationActivity");
        names.push("@momentum-ui/smui/ShuttleSummary");
        names.push("@momentum-ui/smui/KpiTiles");
        names.push("@momentum-ui/smui/MultiSite");
        names.push("@momentum-ui/smui/Summary");
        names.push("@momentum-ui/wesui/AMRRobotics");
        names.push("@momentum-ui/wesui/AlarmSubscriptions");
        names.push("@momentum-ui/wesui/Alarms");
        names.push("@momentum-ui/wesui/CapacityManager");
        names.push("@momentum-ui/wesui/Carts");
        names.push("@momentum-ui/wesui/Compartments");
        names.push("@momentum-ui/wesui/Containers");
        names.push("@momentum-ui/wesui/DataTableDialog");
        names.push("@momentum-ui/wesui/DecisionIntelligence");
        names.push("@momentum-ui/wesui/DeviceStatus");
        names.push("@momentum-ui/wesui/Diverts");
        names.push("@momentum-ui/wesui/DwellTime");
        names.push("@momentum-ui/wesui/ExecutionTask");
        names.push("@momentum-ui/wesui/GtpAssociateDisassociateItems");
        names.push("@momentum-ui/wesui/Gtp");
        names.push("@momentum-ui/wesui/GtpBuilder");
        names.push("@momentum-ui/wesui/GtpViewer");
        names.push("@momentum-ui/wesui/Inventory");
        names.push("@momentum-ui/wesui/Labels");
        names.push("@momentum-ui/wesui/Labor");
        names.push("@momentum-ui/wesui/Locations");
        names.push("@momentum-ui/wesui/Logs");
        names.push("@momentum-ui/wesui/MultiSite");
        names.push("@momentum-ui/wesui/OrderScore");
        names.push("@momentum-ui/wesui/Orders");
        names.push("@momentum-ui/wesui/PickerManagement");
        names.push("@momentum-ui/wesui/PickingDashboard");
        names.push("@momentum-ui/wesui/Printers");
        names.push("@momentum-ui/wesui/Ptl");
        names.push("@momentum-ui/wesui/Robotics");
        names.push("@momentum-ui/wesui/Routing");
        names.push("@momentum-ui/wesui/RulesManagement");
        names.push("@momentum-ui/wesui/Scanners");
        names.push("@momentum-ui/wesui/OrdersSummary");
        names.push("@momentum-ui/wesui/PickingOverview");
        names.push("@momentum-ui/wesui/PickingSummary");
        names.push("@momentum-ui/wesui/SFDSummary");
        names.push("@momentum-ui/wesui/SmartDashboard");
        names.push("@momentum-ui/wesui/SnapInAlarms");
        names.push("@momentum-ui/wesui/SnapInCancelTask");
        names.push("@momentum-ui/wesui/Tasks");
        names.push("@momentum-ui/wesui/Waves");
        names.push("@momentum-ui/wesui/WorkAssignments");
        names.push("@momentum-ui/wesui/WorkZoneStatus");
        return names;
    },

    /**
     * Loads a component catalog module (asynchronous).
     * 
     * @param name
     *      Name of module to load (ex: "@momentum-ui/framework/samples").
     */
    async loadModule(name: string) {
        switch (name) {
            case "@momentum-ui/framework/administration":
                return (await import("@momentum-ui/framework/dist/catalog/administration/catalogModule.g")).default;
            case "@momentum-ui/framework/samples":
                return (await import("@momentum-ui/framework/dist/catalog/samples/catalogModule.g")).default;
            case "@momentum-ui/framework/system":
                return (await import("@momentum-ui/framework/dist/catalog/system/catalogModule.g")).default;
            case "@momentum-ui/reds-ui-extensions/Test":
                return (await import("@momentum-ui/reds-ui-extensions/dist/catalog/Test/catalogModule.g")).default;
            case "@momentum-ui/smui/ASRS":
                return (await import("@momentum-ui/smui/dist/catalog/ASRS/catalogModule.g")).default;
            case "@momentum-ui/smui/ASRSDashboardConfig":
                return (await import("@momentum-ui/smui/dist/catalog/ASRSDashboardConfig/catalogModule.g")).default;
            case "@momentum-ui/smui/ASRSGTPDashboard":
                return (await import("@momentum-ui/smui/dist/catalog/ASRSGTPDashboard/catalogModule.g")).default;
            case "@momentum-ui/smui/ASRSKpis":
                return (await import("@momentum-ui/smui/dist/catalog/ASRSKpis/catalogModule.g")).default;
            case "@momentum-ui/smui/Dashboard":
                return (await import("@momentum-ui/smui/dist/catalog/Dashboard/catalogModule.g")).default;
            case "@momentum-ui/smui/DataTableDialog":
                return (await import("@momentum-ui/smui/dist/catalog/DataTableDialog/catalogModule.g")).default;
            case "@momentum-ui/smui/ACRSummary":
                return (await import("@momentum-ui/smui/dist/catalog/KpiTiles/ACRSummary/catalogModule.g")).default;
            case "@momentum-ui/smui/ASRSTaskSummary":
                return (await import("@momentum-ui/smui/dist/catalog/KpiTiles/ASRSTaskSummary/catalogModule.g")).default;
            case "@momentum-ui/smui/CraneSummary":
                return (await import("@momentum-ui/smui/dist/catalog/KpiTiles/CraneSummary/catalogModule.g")).default;
            case "@momentum-ui/smui/GTPStationActivity":
                return (await import("@momentum-ui/smui/dist/catalog/KpiTiles/GTPStationActivity/catalogModule.g")).default;
            case "@momentum-ui/smui/ShuttleSummary":
                return (await import("@momentum-ui/smui/dist/catalog/KpiTiles/ShuttleSummary/catalogModule.g")).default;
            case "@momentum-ui/smui/KpiTiles":
                return (await import("@momentum-ui/smui/dist/catalog/KpiTiles/catalogModule.g")).default;
            case "@momentum-ui/smui/MultiSite":
                return (await import("@momentum-ui/smui/dist/catalog/MultiSite/catalogModule.g")).default;
            case "@momentum-ui/smui/Summary":
                return (await import("@momentum-ui/smui/dist/catalog/Summary/catalogModule.g")).default;
            case "@momentum-ui/wesui/AMRRobotics":
                return (await import("@momentum-ui/wesui/dist/catalog/AMRRobotics/catalogModule.g")).default;
            case "@momentum-ui/wesui/AlarmSubscriptions":
                return (await import("@momentum-ui/wesui/dist/catalog/AlarmSubscriptions/catalogModule.g")).default;
            case "@momentum-ui/wesui/Alarms":
                return (await import("@momentum-ui/wesui/dist/catalog/Alarms/catalogModule.g")).default;
            case "@momentum-ui/wesui/CapacityManager":
                return (await import("@momentum-ui/wesui/dist/catalog/CapacityManager/catalogModule.g")).default;
            case "@momentum-ui/wesui/Carts":
                return (await import("@momentum-ui/wesui/dist/catalog/Carts/catalogModule.g")).default;
            case "@momentum-ui/wesui/Compartments":
                return (await import("@momentum-ui/wesui/dist/catalog/Containers/Compartments/catalogModule.g")).default;
            case "@momentum-ui/wesui/Containers":
                return (await import("@momentum-ui/wesui/dist/catalog/Containers/catalogModule.g")).default;
            case "@momentum-ui/wesui/DataTableDialog":
                return (await import("@momentum-ui/wesui/dist/catalog/DataTableDialog/catalogModule.g")).default;
            case "@momentum-ui/wesui/DecisionIntelligence":
                return (await import("@momentum-ui/wesui/dist/catalog/DecisionIntelligence/catalogModule.g")).default;
            case "@momentum-ui/wesui/DeviceStatus":
                return (await import("@momentum-ui/wesui/dist/catalog/DeviceStatus/catalogModule.g")).default;
            case "@momentum-ui/wesui/Diverts":
                return (await import("@momentum-ui/wesui/dist/catalog/Diverts/catalogModule.g")).default;
            case "@momentum-ui/wesui/DwellTime":
                return (await import("@momentum-ui/wesui/dist/catalog/DwellTime/catalogModule.g")).default;
            case "@momentum-ui/wesui/ExecutionTask":
                return (await import("@momentum-ui/wesui/dist/catalog/ExecutionTask/catalogModule.g")).default;
            case "@momentum-ui/wesui/GtpAssociateDisassociateItems":
                return (await import("@momentum-ui/wesui/dist/catalog/Gtp/GtpAssociateDisassociateItems/catalogModule.g")).default;
            case "@momentum-ui/wesui/Gtp":
                return (await import("@momentum-ui/wesui/dist/catalog/Gtp/catalogModule.g")).default;
            case "@momentum-ui/wesui/GtpBuilder":
                return (await import("@momentum-ui/wesui/dist/catalog/GtpBuilder/catalogModule.g")).default;
            case "@momentum-ui/wesui/GtpViewer":
                return (await import("@momentum-ui/wesui/dist/catalog/GtpViewer/catalogModule.g")).default;
            case "@momentum-ui/wesui/Inventory":
                return (await import("@momentum-ui/wesui/dist/catalog/Inventory/catalogModule.g")).default;
            case "@momentum-ui/wesui/Labels":
                return (await import("@momentum-ui/wesui/dist/catalog/Labels/catalogModule.g")).default;
            case "@momentum-ui/wesui/Labor":
                return (await import("@momentum-ui/wesui/dist/catalog/Labor/catalogModule.g")).default;
            case "@momentum-ui/wesui/Locations":
                return (await import("@momentum-ui/wesui/dist/catalog/Locations/catalogModule.g")).default;
            case "@momentum-ui/wesui/Logs":
                return (await import("@momentum-ui/wesui/dist/catalog/Logs/catalogModule.g")).default;
            case "@momentum-ui/wesui/MultiSite":
                return (await import("@momentum-ui/wesui/dist/catalog/MultiSite/catalogModule.g")).default;
            case "@momentum-ui/wesui/OrderScore":
                return (await import("@momentum-ui/wesui/dist/catalog/OrderScore/catalogModule.g")).default;
            case "@momentum-ui/wesui/Orders":
                return (await import("@momentum-ui/wesui/dist/catalog/Orders/catalogModule.g")).default;
            case "@momentum-ui/wesui/PickerManagement":
                return (await import("@momentum-ui/wesui/dist/catalog/PickerManagement/catalogModule.g")).default;
            case "@momentum-ui/wesui/PickingDashboard":
                return (await import("@momentum-ui/wesui/dist/catalog/PickingDashboard/catalogModule.g")).default;
            case "@momentum-ui/wesui/Printers":
                return (await import("@momentum-ui/wesui/dist/catalog/Printers/catalogModule.g")).default;
            case "@momentum-ui/wesui/Ptl":
                return (await import("@momentum-ui/wesui/dist/catalog/Ptl/catalogModule.g")).default;
            case "@momentum-ui/wesui/Robotics":
                return (await import("@momentum-ui/wesui/dist/catalog/Robotics/catalogModule.g")).default;
            case "@momentum-ui/wesui/Routing":
                return (await import("@momentum-ui/wesui/dist/catalog/Routing/catalogModule.g")).default;
            case "@momentum-ui/wesui/RulesManagement":
                return (await import("@momentum-ui/wesui/dist/catalog/RulesManagement/catalogModule.g")).default;
            case "@momentum-ui/wesui/Scanners":
                return (await import("@momentum-ui/wesui/dist/catalog/Scanners/catalogModule.g")).default;
            case "@momentum-ui/wesui/OrdersSummary":
                return (await import("@momentum-ui/wesui/dist/catalog/SmartDashboard/OrdersSummary/catalogModule.g")).default;
            case "@momentum-ui/wesui/PickingOverview":
                return (await import("@momentum-ui/wesui/dist/catalog/SmartDashboard/PickingOverview/catalogModule.g")).default;
            case "@momentum-ui/wesui/PickingSummary":
                return (await import("@momentum-ui/wesui/dist/catalog/SmartDashboard/PickingSummary/catalogModule.g")).default;
            case "@momentum-ui/wesui/SFDSummary":
                return (await import("@momentum-ui/wesui/dist/catalog/SmartDashboard/SFDSummary/catalogModule.g")).default;
            case "@momentum-ui/wesui/SmartDashboard":
                return (await import("@momentum-ui/wesui/dist/catalog/SmartDashboard/catalogModule.g")).default;
            case "@momentum-ui/wesui/SnapInAlarms":
                return (await import("@momentum-ui/wesui/dist/catalog/SnapInAlarms/catalogModule.g")).default;
            case "@momentum-ui/wesui/SnapInCancelTask":
                return (await import("@momentum-ui/wesui/dist/catalog/SnapInCancelTask/catalogModule.g")).default;
            case "@momentum-ui/wesui/Tasks":
                return (await import("@momentum-ui/wesui/dist/catalog/Tasks/catalogModule.g")).default;
            case "@momentum-ui/wesui/Waves":
                return (await import("@momentum-ui/wesui/dist/catalog/Waves/catalogModule.g")).default;
            case "@momentum-ui/wesui/WorkAssignments":
                return (await import("@momentum-ui/wesui/dist/catalog/WorkAssignments/catalogModule.g")).default;
            case "@momentum-ui/wesui/WorkZoneStatus":
                return (await import("@momentum-ui/wesui/dist/catalog/WorkZoneStatus/catalogModule.g")).default;
            default: {
                return undefined; 
            } 
        }
    }
};
export default catalog;
